"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedRechargeTableConf = exports.autoRechargingTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var constants_2 = require("../constants");
var AccCurrencyCode_1 = __importDefault(require("./CellComponents/AccCurrencyCode"));
var CurrencyCode_1 = __importDefault(require("./CellComponents/CurrencyCode"));
var CustomerActionsDropdown_1 = __importDefault(require("./CellComponents/CustomerActionsDropdown"));
var RechargeMargin_1 = __importDefault(require("./CellComponents/RechargeMargin"));
var Status_1 = __importDefault(require("./CellComponents/Status"));
var TaxTypeButton_1 = __importDefault(require("./CellComponents/TaxTypeButton"));
var utils_1 = require("./utils");
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XSM = constants_1.CellSize.XSM;
exports.autoRechargingTableConf = {
    headersMap: {
        name: 'Customers',
        isTaxExcluded: 'Tax Rate',
        date: 'Billing Start - End',
        clientDiscount: 'Discount',
        accFirmCurrency: '',
        rechargeMargin: 'Margin',
    },
    headerTooltip: {
        isTaxExcluded: {
            description: '**Tax rate** is the applicable sales tax for each customer, such as:',
            list: ['Zero (Exempt clients)', 'GST (Australia, New Zealand)', 'VAT (UK, Europe)', 'Sales tax (USA)'],
        },
        listPrice: {
            description: '**List price** is the vendors Recommended Retail Price(RRP) for a given plan, tax exclusive.',
        },
        clientPrice: {
            description: '**Client price** is the **List price** minus the discount that you pass on to your customer, tax exclusive.',
        },
        clientDiscount: { description: 'This is the percentage of **discount** that you pass on to your customer.' },
        rechargeMargin: { description: 'This is the **recharge margin** that your firm keeps from the available partner discount.' },
    },
    extractors: {
        date: function (item) { return ((item === null || item === void 0 ? void 0 : item.startDate) && (item === null || item === void 0 ? void 0 : item.endDate)) && (0, end2end_1.getDateRange)(item.startDate, item.endDate); },
        isTaxExcluded: function (item) { return item.isTaxExcluded ? 0 : 1; },
        rechargeMargin: function (item) { return item.totalDiscount * item.discountSplit; },
        status: utils_1.getBillingStatus,
    },
    sortMapper: {
        status: Object.fromEntries(constants_2.BILLING_STATUS_ORDER.map(function (v, i) { return [v, i]; })),
    },
    cells: [
        {
            field: 'name',
            cell: { width: XL, offset: 'left' },
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('customer'),
        },
        { field: 'isTaxExcluded', cell: { width: SM, textAlign: 'left' }, renderComponent: TaxTypeButton_1.default },
        { field: 'date', cell: { width: LG, textAlign: 'right' }, truncate: {} },
        { field: 'listPrice', cell: { width: MD }, money: {} },
        { field: 'accFirmCurrency', cell: { hasGutter: false, width: XSM, textAlign: 'left' }, renderComponent: CurrencyCode_1.default },
        { field: 'clientPrice', cell: { width: MD }, money: {} },
        { field: 'clientDiscount', cell: { width: MD, textAlign: 'center' }, renderField: end2end_1.formatPercentagePrecise },
        { field: 'rechargeMargin', cell: { width: MD }, renderComponent: RechargeMargin_1.default },
        { field: 'status', cell: { width: LG }, renderComponent: Status_1.default },
        { key: 'actions', cell: { width: SM }, renderComponent: CustomerActionsDropdown_1.default, stopPropagation: true },
    ],
};
exports.extendedRechargeTableConf = {
    row: {
        isTitle: false,
        sizing: 'tight',
    },
    extractors: {
        date: function (item) { return (item.startDate && item.endDate) && (0, end2end_1.getDateRange)(item.startDate, item.endDate); },
        description: function (item) { return (0, end2end_1.getRechargeDescription)(item, item.rechargedOrganization, item.hasMultipleOrgs, item.hasPriceOverride); },
        rechargeMargin: function (item) { var _a; return ((((_a = item === null || item === void 0 ? void 0 : item.discount) !== null && _a !== void 0 ? _a : 0) / 100) - item.reducedDiscount) * item.listPriceInAccFirmCurrency; },
    },
    cells: [
        { field: 'description', cell: { width: XL, offset: 'left' }, truncate: {} },
        { key: 'empty1', cell: { width: SM } },
        { field: 'date', cell: { width: LG, textAlign: 'right' } },
        { field: 'listPriceInAccFirmCurrency', cell: { width: MD }, money: {} },
        { field: 'accFirmCurrency', cell: { hasGutter: false, width: XSM, textAlign: 'left' }, renderComponent: AccCurrencyCode_1.default },
        { field: 'clientPrice', cell: { width: MD }, money: {} },
        { field: 'reducedDiscount', cell: { width: MD, textAlign: 'center' }, renderField: end2end_1.formatPercentage },
        { field: 'rechargeMargin', cell: { width: MD, textAlign: 'left', offset: 'left' }, money: {} },
        { key: 'empty2', cell: { width: LG } },
    ],
};
